import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SDCXUninstallLinux() {
    return (
        <React.Fragment>
            <p>To uninstall the Signiant SDCX Server, run the uninstaller script in your terminal:</p>

            <p>
                <code className="language-text">sudo /usr/Signiant_Media_Shuttle/bin/siguninstall</code>
            </p>

            <p>
                The <code className="language-text">siguninstall</code> command removes the SDCX Server and all
                associated applications from your system.
            </p>
            <p>
                To reinstall the server after removal, follow the installation procedure using a new registration key.
            </p>
        </React.Fragment>
    );
}

SDCXUninstallLinux.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SDCXUninstallLinux);
